/**
 * Order Data
 */
import { OrderType, PayMethod } from "./model";
import {SaleMode} from "./apps";

export class Order {
  shopId: number;
  userId: number;
  type: OrderType;
  qrType: string;
  payMethod: PayMethod;
  tableNo: string;
  txId: number;      // tabletious ord no
  total: number;    // 합계금액. 서버에서 다시 계산해서 체크할 것
  items: OrderItem[];

  name: string;   // for takeaway order
  mobile: string; // for takeaway order

  constructor(shopId: number, userId: number, orderType: OrderType, qrType: string, payMethod: PayMethod,
              tableNo: string, txId: number, total: number, items: OrderItem[],
              name: string, mobile: string) {
    this.shopId = shopId;
    this.userId = userId;
    this.type = orderType;
    this.qrType = qrType;
    this.payMethod = payMethod;
    this.tableNo = tableNo;
    this.txId = txId;
    this.total = total;
    this.items = items;
    this.name = name;
    this.mobile = mobile;
  }
}

export class OrderItem {
  menuId: number;
  qty: number;
  options: string;  // tagOptions()에 의해서 만들어지는 option 선택 값
  itemPrice: number;  // menu.price + sum(selected_option_item.price)
  saleMode: SaleMode;
  note: string;  // 항목별 메모(선택, CartItem.note). 서버 OrderItemData.note로 매핑

  constructor(menuId: number, qty: number, options: string, itemPrice: number, saleMode: SaleMode, note: string = "") {
    this.menuId = menuId;
    this.qty = qty;
    this.options = options;
    this.itemPrice = itemPrice;  // menu.price + sum(selected_option_item.price)
    this.saleMode = saleMode;
    this.note = note;
  }
}

export enum OrderStatus {
  PLACED = "PLACED",
  SENT = "SENT",
  CONFIRMED = "CONFIRMED",
  REJECTED = "REJECTED",
  CANCELED = "CANCELED",
  TIMEOUT = "TIMEOUT",
  FAILED = "FAILED",
  WAITING_PAYMENT = "WAITING_PAYMENT",
}

export class OrderPlaceRes {
  orderId: number;
  orderStatus: OrderStatus;

  constructor(orderId: number, orderStatus: OrderStatus) {
    this.orderId = orderId;
    this.orderStatus = orderStatus;
  }
}

/**
 * order status:
 * PLACED, SENT, CONFIRMED, REJECTED, CANCELED, TIMEOUT, FAILED, WAITING_PAYMENT
 */
export class OrderStatusRes {
  orderId: number;
  ordNo: number;
  orderStatus: string;
  error: string;

  constructor(orderId: number, orderStatus: string, error: string) {
    this.orderId = orderId;
    this.orderStatus = orderStatus;
    this.error = error;
  }
}

/** 테이블 세션(shop+txId) 주문목록 다시보기 — GET /order/session/{shopId}/{orderId} */
export interface ItemLine {
  name: string;
  qty: number;
  price: number;
  amount: number;
  menuId?: number;    // 썸네일용(서버 미배포 호환 optional)
  imageVer?: number;
  note?: string;      // 항목별 메모. 서버 OrderSessionRes.ItemLine이 아직 note를 안 내려줌 — 배포 전까지 항상 undefined.
  options?: string;   // 선택 옵션 표시 텍스트(예: "Large, Cheese, Bacon"). 서버 OrderSessionRes.ItemLine.options
}
export interface OrderLine {
  orderId: number;
  ordNo: number;
  status: string;
  placed: string;
  placedDate: string;   // 매장 State 시간대 날짜(서버 계산, 예: "Wed, 2 Jul 2026")
  placedTime: string;   // 매장 State 시간대 12시간 시각(서버 계산, 예: "1:16 PM")
  total: number;        // 메뉴 소계(order.total) — 비카드 Order Total
  subtotal: number;     // 카드=영수증 original_amount, 그 외=order.total (수수료 전)
  surcharge: number;    // 카드 수수료(영수증), 없으면 0
  grandTotal: number;   // 실결제액: 카드=영수증 total, 그 외=order.total
  items: ItemLine[];
}
export interface OrderSessionRes {
  shopId: string;
  txId: number;
  tableNo: string;
  orders: OrderLine[];
  tableTotal: number;
}


